import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { PlanDto } from '@workspace/data-types';
import { LuxonDatePipe } from '@workspace/ng-aura';
import { PriceDisplayPipe } from '@workspace/ng-data-access';

@Component({
  selector: 'core-plan-details',
  templateUrl: './plan-details.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PriceDisplayPipe,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    LuxonDatePipe,
    CommonModule,
    RouterModule,
  ],
})
export class PlanDetailsCoreComponent {
  plan = input.required<PlanDto>();
}
